import { useEffect, useRef } from 'react';

export const useTilt = (options = {}) => {
  const ref = useRef(null);
  const {
    max = 15,
    perspective = 1000,
    scale = 1.05,
    speed = 400,
    easing = 'cubic-bezier(0.23, 1, 0.32, 1)',
  } = options;

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    let timeout;

    const handleMouseMove = (e) => {
      const rect = element.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const rotateX = ((y - centerY) / centerY) * max;
      const rotateY = ((centerX - x) / centerX) * max;

      element.style.transform = `
        perspective(${perspective}px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
        scale3d(${scale}, ${scale}, ${scale})
      `;
    };

    const handleMouseLeave = () => {
      timeout = setTimeout(() => {
        element.style.transform = `
          perspective(${perspective}px)
          rotateX(0deg)
          rotateY(0deg)
          scale3d(1, 1, 1)
        `;
      }, 100);
    };

    const handleMouseEnter = () => {
      clearTimeout(timeout);
    };

    element.style.transition = `transform ${speed}ms ${easing}`;
    element.style.transformStyle = 'preserve-3d';

    element.addEventListener('mousemove', handleMouseMove);
    element.addEventListener('mouseleave', handleMouseLeave);
    element.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      element.removeEventListener('mousemove', handleMouseMove);
      element.removeEventListener('mouseleave', handleMouseLeave);
      element.removeEventListener('mouseenter', handleMouseEnter);
      clearTimeout(timeout);
    };
  }, [max, perspective, scale, speed, easing]);

  return ref;
};
